import {SummaryDataType} from './SummarizedDataGridType';
import FilterTextField from '../../../common/arr-data-grid-pro/filter-components/text-field/FilterTextField';
import {t} from 'i18next';
import CellWrapper from '../../../common/arr-data-grid-pro/filter-components/cell-wrapper/CellWrapper';
import {
  GridColumnHeaderParams,
  GridRenderCellParams,
  GridRenderHeaderFilterProps,
} from '@mui/x-data-grid-pro';
import ArrIconButton from '../../../common/arr-icon-button/ArrIconButton';
import {ReactComponent as DeleteIcon} from '../../../../assets/images/delete.svg';
import ArrButton from '../../../common/arr-button/ArrButton';
import ArrTooltipWrapper from '../../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import {ReactComponent as InfoIcon} from '../../../../assets/images/info-icon.svg';
import {ReactComponent as ResetIcon} from '../../../../assets/images/icon-reset.svg';
import {Box, Typography} from '@mui/material';
import {ReactNode} from 'react';
import {formatDateTime} from '../../../../utils/utils';
import {ISummarizationNavigationPayload} from '../../../../api/types/aiSummarization.type';
import ArrTooltip from '../../../common/arr-tooltip/ArrTooltip';

const DocsTooltipInfo = () => (
  <>
    <p data-testid={`summarize-data-grid-data-tooltip1`}>
      {t('ai.summarize.tooltip.excludedDocs.tooltip1')}
    </p>
    <p data-testid={`summarize-data-grid-data-tooltip2`}>
      {t('ai.summarize.tooltip.excludedDocs.tooltip2')}
    </p>
    <ul
      data-testid={`summarize-data-grid-data-tooltip3-tooltip8-tooltip4-tooltip5-tooltip6-tooltip7`}
    >
      <li data-testid={`summarize-data-grid-data-tooltip3`}>
        {t('ai.summarize.tooltip.excludedDocs.tooltip3')}
      </li>
      <li data-testid={`summarize-data-grid-data-tooltip8`}>
        {t('ai.summarize.tooltip.excludedDocs.tooltip8')}
      </li>
      <li data-testid={`summarize-data-grid-data-tooltip4`}>
        {t('ai.summarize.tooltip.excludedDocs.tooltip4')}
      </li>
      <li data-testid={`summarize-data-grid-data-tooltip5`}>
        {t('ai.summarize.tooltip.excludedDocs.tooltip5')}
      </li>
      <li data-testid={`summarize-data-grid-data-tooltip6`}>
        {t('ai.summarize.tooltip.excludedDocs.tooltip6')}
      </li>
      <li data-testid={`summarize-data-grid-data-tooltip7`}>
        {t('ai.summarize.tooltip.excludedDocs.tooltip7')}
      </li>
    </ul>
  </>
);
const HEADER_MIN_WIDTH = 112;
export const columns = (
  onDeletePress: (selectedData: SummaryDataType) => void,
  onRetryData: (selectedData: SummaryDataType) => void,
  navigationDocs: (payload: ISummarizationNavigationPayload) => void
) => [
  {
    field: 'jobId',
    headerName: 'Job ID',
    minWidth: HEADER_MIN_WIDTH,
    filterable: false,
    height: 64,
    headerClassName: 'jobId-header',
    cellClassName: 'jobId-cell',
    renderHeader: (params: GridColumnHeaderParams) => {
      return (
        <Box
          className="ai-summarize-grid-header"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Tab' && e.shiftKey) {
              e.preventDefault();
              (
                document.querySelector(
                  '[data-testid="create-new-job"]'
                ) as HTMLElement
              )?.focus();
            }
          }}
        >
          {params.colDef.headerName}
        </Box>
      );
    },
    renderCell: (params: GridRenderCellParams) => {
      return (
        <CellWrapper
          toolTipContent={params.value}
          cellParams={params}
          dataTestId={`tooltip-summarize-data-grid-jobId-${params.id}`}
        >
          <span
            tabIndex={0}
            role="gridcell"
            data-testid={`summarize-data-grid-jobId-${params.id}`}
          >
            {params.value}
          </span>
        </CellWrapper>
      );
    },
  },
  {
    field: 'dateSubmitted',
    headerName: 'Date Submitted',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    filterable: false,
    renderCell: (params: any) => (
      <CellWrapper
        toolTipContent={formatDateTime(params.value)}
        cellParams={params}
        dataTestId={`tooltip-summarize-data-grid-dateSubmitted-${params.id}`}
      >
        <span
          className="date-submitted-text"
          data-testid={`summarize-data-grid-dateSubmitted-${params.id}`}
        >
          {formatDateTime(params.value)}
        </span>
      </CellWrapper>
    ),
    renderHeader: (params: GridColumnHeaderParams) => {
      return (
        <Box className="ai-summarize-grid-header" tabIndex={0}>
          {params.colDef.headerName}
        </Box>
      );
    },
  },
  {
    field: 'dateCompleted',
    headerName: 'Date Completed',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    filterable: false,
    renderCell: (params: any) => (
      <CellWrapper
        toolTipContent={formatDateTime(params.value)}
        cellParams={params}
        dataTestId={`tooltip-summarize-data-grid-dateCompleted-${params.id}`}
      >
        <span
          className="date-completed-text"
          data-testid={`summarize-data-grid-dateCompleted-${params.id}`}
        >
          {formatDateTime(params.value)}
        </span>
      </CellWrapper>
    ),
    renderHeader: (params: GridColumnHeaderParams) => {
      return (
        <Box className="ai-summarize-grid-header" tabIndex={0}>
          {params.colDef.headerName}
        </Box>
      );
    },
  },
  {
    field: 'submittedBy',
    headerName: 'Submitted By',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    renderHeaderFilter: (params: GridRenderHeaderFilterProps) => {
      return (
        <FilterTextField
          dataTestId={`submittedBy`}
          gridRenderHeaderFilterProps={params}
          placeholder={t('common.filter')}
          className="custom-filter"
        />
      );
    },
    renderCell: (params: GridRenderCellParams) => {
      return (
        <CellWrapper
          toolTipContent={params.value}
          cellParams={params}
          dataTestId={`tooltip-summarize-data-grid-data-submittedby-${params.id}`}
        >
          <span
            tabIndex={0}
            role="gridcell"
            data-testid={`summarize-data-grid-data-submittedBy-${params.id}`}
          >
            {params.value}
          </span>
        </CellWrapper>
      );
    },
    renderHeader: (params: GridColumnHeaderParams) => {
      return (
        <Box className="ai-summarize-grid-header" tabIndex={0}>
          {params.colDef.headerName}
        </Box>
      );
    },
  },
  {
    field: 'source',
    headerName: 'Source',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    renderHeaderFilter: (params: GridRenderHeaderFilterProps) => {
      return (
        <FilterTextField
          dataTestId={`source`}
          gridRenderHeaderFilterProps={params}
          placeholder={t('common.filter')}
          className="custom-filter"
        />
      );
    },
    renderCell: (params: GridRenderCellParams) => {
      return (
        <CellWrapper
          toolTipContent={params.value}
          dataTestId={`tooltip-summarize-data-grid-source--${params.id}`}
          cellParams={params}
        >
          <span
            tabIndex={0}
            role="gridcell"
            data-testid={`summarize-data-grid-source--${params.id}`}
          >
            {params.value}
          </span>
        </CellWrapper>
      );
    },
    renderHeader: (params: GridColumnHeaderParams) => {
      return (
        <Box className="ai-summarize-grid-header" tabIndex={0}>
          {params.colDef.headerName}
        </Box>
      );
    },
  },
  {
    field: 'submittedDocCount',
    headerName: 'Submitted Docs',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    filterable: false,
    renderCell: (params: any) => {
      const isCellCountZero = params.row.submittedDocCount === 0;
      const cellContent = isCellCountZero ? (
        <CellWrapper
          toolTipContent={params.value}
          dataTestId={`tooltip-summarize-data-grid-data-submitted-doc-count-${params.id}`}
          cellParams={params}
        >
          <Typography
            className=" typo-text body3_size"
            role="gridcell"
            tabIndex={0}
            data-testid={`summarize-data-grid-data-submitted-doc-count-${params.id}`}
          >
            {params.value}
          </Typography>
        </CellWrapper>
      ) : (
        <ArrButton
          onClick={() =>
            navigationDocs({
              jobId: params.row.jobId,
              statusCode: 'SUBMITTED',
            })
          }
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.code === 'Space') {
              e.stopPropagation();
              navigationDocs({
                jobId: params.row.jobId,
                statusCode: 'SUBMITTED',
              });
            }
          }}
          variant="text"
          size="xs"
          className="id-cell-preview"
          dataTestId={`${params.id}-submitted`}
        >
          <Typography
            className="doc-id-cell typo-text body3_size"
            data-testid={`summarize-data-grid-doc-count-button-${params.id}`}
          >
            {params.value}
          </Typography>
        </ArrButton>
      );

      return (
        <CellWrapper
          dataTestId={`doclist-column-${params.value}`}
          className="cell-docs ai-summarize-cell-wrapper"
          tabIndex={-1}
          cellParams={params}
        >
          {cellContent}
        </CellWrapper>
      );
    },
    renderHeader: (params: GridColumnHeaderParams) => {
      return (
        <Box className="ai-summarize-grid-header" tabIndex={0}>
          {params.colDef.headerName}
        </Box>
      );
    },
  },
  {
    field: 'completedDocCount',
    headerName: 'Completed Docs',
    flex: 1,
    minWidth: HEADER_MIN_WIDTH,
    filterable: false,
    renderCell: (params: any) => {
      let cellContent: ReactNode;
      const isCompletedDocCountZero = params.row.completedDocCount === 0;
      if (params.row.status !== 'InQueue') {
        cellContent = isCompletedDocCountZero ? (
          <CellWrapper
            toolTipContent={params.value}
            cellParams={params}
            dataTestId={`tooltip-summarize-data-grid-completed-zero-${params.id}`}
          >
            <Typography
              className="typo-text body3_size"
              tabIndex={0}
              role="gridcell"
              aria-label={t('ai.summarize.grid.completedDocCountAriaLabel')}
              data-testid={`summarize-data-grid-completed-zero-${params.id}`}
            >
              {params.value}
            </Typography>
          </CellWrapper>
        ) : (
          <ArrButton
            onClick={() =>
              navigationDocs({
                jobId: params.row.jobId,
                statusCode: 'COMPLETED',
              })
            }
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.code === 'Space') {
                e.stopPropagation();
                navigationDocs({
                  jobId: params.row.jobId,
                  statusCode: 'COMPLETED',
                });
              }
            }}
            variant="text"
            size="xs"
            className="id-cell-preview"
            dataTestId={`${params.id}-completed`}
          >
            <Typography
              className="doc-id-cell typo-text body3_size"
              data-testid={`summarize-data-grid-completed-button-${params.id}`}
            >
              {params.value}
            </Typography>
          </ArrButton>
        );
      } else {
        cellContent = (
          <Typography
            tabIndex={0}
            role="gridcell"
            aria-label={t('ai.summarize.grid.noCompletedDocsAriaLabel')}
            data-testid={`summarize-data-grid-empty-${params.id}`}
          >
            {'--'}
          </Typography>
        );
      }
      return (
        <CellWrapper
          dataTestId={`doclist-column-${params.value}`}
          tabIndex={-1}
          className="cell-docs ai-summarize-cell-wrapper"
          cellParams={params}
        >
          {cellContent}
        </CellWrapper>
      );
    },
    renderHeader: (params: GridColumnHeaderParams) => {
      return (
        <Box className="ai-summarize-grid-header" tabIndex={0}>
          {params.colDef.headerName}
        </Box>
      );
    },
  },
  {
    field: 'excludedDocCount',
    headerName: 'Excluded Docs',
    flex: 1,
    filterable: false,
    minWidth: HEADER_MIN_WIDTH,
    renderCell: (params: any) => {
      let cellContent: ReactNode;
      const isExcludedDocCountZero = params.row.excludedDocCount === 0;
      if (params.row.status !== 'InQueue') {
        cellContent = isExcludedDocCountZero ? (
          <CellWrapper
            toolTipContent={params.value}
            dataTestId={`tooltip-summarize-data-excluded-count-${params.id}`}
            cellParams={params}
          >
            <Typography
              className="typo-text body3_size"
              role="gridcell"
              aria-label={t('ai.summarize.grid.excludedDocCountAriaLabel')}
              tabIndex={0}
              data-testid={`summarize-data-excluded-count-${params.id}`}
            >
              {params.value}
            </Typography>
          </CellWrapper>
        ) : (
          <ArrButton
            onClick={() =>
              navigationDocs({
                jobId: params.row.jobId,
                statusCode: 'EXCLUDED',
              })
            }
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.code === 'Space') {
                e.stopPropagation();
                navigationDocs({
                  jobId: params.row.jobId,
                  statusCode: 'EXCLUDED',
                });
              }
            }}
            variant="text"
            size="xs"
            className="id-cell-preview"
            dataTestId={`${params.id}-excluded`}
          >
            <Typography
              className="doc-id-cell typo-text body3_size"
              data-testid={`summarize-data-excluded-button-${params.id}`}
            >
              {params.value}
            </Typography>
          </ArrButton>
        );
      } else {
        cellContent = (
          <Typography
            tabIndex={0}
            role="gridcell"
            aria-label={t('ai.summarize.grid.noExludedDocAvailableAriaLabel')}
            data-testid={`summarize-data-excluded-empty-${params.id}`}
          >
            {'--'}
          </Typography>
        );
      }
      return (
        <CellWrapper
          dataTestId={`excluded-column-${params.value}`}
          className="cell-docs"
          tabIndex={-1}
          cellParams={params}
        >
          {cellContent}
        </CellWrapper>
      );
    },
    renderHeader: (params: GridColumnHeaderParams) => (
      <Box
        className="grid-column-excludeddocs-tooltip"
        sx={{display: 'flex', alignItems: 'center'}}
      >
        {params.colDef.headerName}
        <ArrTooltipWrapper
          title={t('ai.summarize.grid.excludedDocs')}
          closeTooltipOnEscPress
          trigger={
            <InfoIcon
              fontSize="medium"
              tabIndex={0}
              role="button"
              aria-label={t('ai.summarize.grid.viewMoreInfoAriaLabel')}
              className="summarize-grid-info-icon"
              data-testid="excluded-docs"
            />
          }
        >
          {DocsTooltipInfo()}
        </ArrTooltipWrapper>
      </Box>
    ),
  },
  {
    field: 'status',
    headerName: 'Status',
    headerClassName: 'status-header',
    flex: 1,
    cellClassName: 'status-cell',
    minWidth: HEADER_MIN_WIDTH,
    renderHeader: (params: GridColumnHeaderParams) => (
      <Box
        className="grid-column-status-tooltip"
        sx={{display: 'flex', alignItems: 'center'}}
      >
        {params.colDef.headerName}
        <ArrTooltipWrapper
          title={t('ai.summarize.grid.status')}
          isVisibleOnFocus
          trigger={
            <InfoIcon
              fontSize="medium"
              tabIndex={0}
              aria-label={t('ai.summarize.tooltip.status')}
              aria-describedby={t('ai.summarize.tooltip.status')}
              role="button"
              className="summarize-grid-info-icon"
              data-testid="grid-status-info-icon"
            />
          }
        >
          {t('ai.summarize.tooltip.status')}
        </ArrTooltipWrapper>
      </Box>
    ),
    renderHeaderFilter: (params: GridRenderHeaderFilterProps) => {
      return (
        <FilterTextField
          dataTestId={`status`}
          gridRenderHeaderFilterProps={params}
          placeholder={t('common.filter')}
          className="custom-filter"
        />
      );
    },
    renderCell: (param: GridRenderCellParams) => {
      const getStatusClass = (value: string) => {
        switch (value) {
          case 'Completed':
            return 'status-completed';
          case 'Failed':
            return 'status-failed';
          case 'In Progress':
            return 'status-inprogress';
          case 'Remaining':
            return 'status-remaining';
          default:
            return '';
        }
      };

      return (
        <CellWrapper className="cell-status">
          <CellWrapper
            toolTipContent={param.value}
            dataTestId={`cell-wrapper-tooltip-content-status-${param.value}`}
            cellParams={param}
            tabIndex={-1}
          >
            <Typography
              className={`cell-content typo-text body3_size ${getStatusClass(
                param.value as string
              )}`}
              data-testid={`status--${param.id}`}
              role="gridcell"
              tabIndex={0}
            >
              {param.value}
            </Typography>
          </CellWrapper>
          {param.value === 'Failed' && (
            <ArrIconButton
              onClick={() => onRetryData(param.row)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.code === 'Space') {
                  e.preventDefault();
                  e.stopPropagation;
                  onRetryData(param.row);
                }
              }}
              ariaLabel={t('docExplorer.header.reset')}
              icon={<ResetIcon fontSize="medium" />}
              shape="none"
              className="grid-reset-icon"
              testId={`status-failed-icon-${param.id}`}
            />
          )}
        </CellWrapper>
      );
    },
  },
  {
    field: 'delete',
    headerName: '',
    filterable: false,
    sortable: false,
    width: 64,
    renderCell: (param: GridRenderCellParams) => {
      if (
        param.row.status !== 'In Progress' &&
        param.row.status !== 'Completed'
      )
        return (
          <CellWrapper
            toolTipContent={param.value}
            tabIndex={-1}
            dataTestId={`cell-wrapper-tooltip-content-delete-${param.value}`}
            cellParams={param}
          >
            <ArrIconButton
              testId={`arr-delete-icon-${param.row.jobId}`}
              onClick={() =>
                onDeletePress(param.row as unknown as SummaryDataType)
              }
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.code === 'Space') {
                  e.preventDefault();
                  e.stopPropagation();
                  onDeletePress(param.row as unknown as SummaryDataType);
                }
              }}
              icon={<DeleteIcon />}
              ariaLabel={'delete-icon'}
              shape="none"
            ></ArrIconButton>
          </CellWrapper>
        );
    },
  },
];
